module.exports = {
  OK: 200,
  NOT_OK: 300,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  EVERYTHING_BROKE: 500,
};
